import script from "./HomeV2.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeV2.vue?vue&type=script&setup=true&lang=js"

import "./HomeV2.vue?vue&type=style&index=0&id=31e5ce88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e5ce88"]])

export default __exports__